import cls from "classnames";
import FieldWrapper from "./FieldWrapper";

export default function CategoryField({
  label,
  type,
  name,
  placeholder,
  onChange,
  disabled,
  formatValue,
  validator,
  required,
  hint,
  error,
  value,
  options,
  visible,
  className,
  formOptions,
}) {
  function getMergedCategories() {
    const { categories } = formOptions;

    const sortedCategories =
      categories &&
      Object.values(categories).sort((a, b) => a?.order - b?.order);

    let mergedCategories = [];

    sortedCategories?.forEach((subCategory) => {
      mergedCategories = [...mergedCategories, ...subCategory.categories];
    });

    return mergedCategories;
  }

  const categories = getMergedCategories();

  function handleOnChange(category) {
    onChange(
      { target: { name, value: category } },
      formatValue,
      validator,
      required
    );
  }

  return (
    <FieldWrapper error={error} hint={hint} visible={visible}>
      {label && (
        <label htmlFor="input" className="font-semibold text-sm">
          {label}
        </label>
      )}
      <div className="flex flex-wrap items-center justify-start gap-2">
        {categories.map((option, index) => {
          const selected = value?.uid === option.uid;
          return (
            <button
              key={index}
              className={cls(
                "border-[1px] outline-none rounded-full h-auto px-3 py-2 text-sm leading-4 hover:border-[#384AF1]",
                selected
                  ? "bg-[#E4E7FF] border-[#384AF1]"
                  : "bg-white border-[#D5D8DC]"
              )}
              onClick={() => handleOnChange(option)}
            >
              <span className="mr-2 w-4 text-xs">{option.emoji_unicode}</span>
              {option.display_name}
            </button>
          );
        })}
      </div>
    </FieldWrapper>
  );
}
